/**
 * API may persist price 0 when a variant/packing has no price on a table.
 * A matching row with value 0 must be treated as "sem preço".
 * Missing `price` (undefined) still counts as present for older payloads.
 */
export function isZeroListedPrice(price: unknown): boolean {
	return Number(price) === 0;
}

export function hasPriceOnList(
	prices: { price?: number; priceListId?: number }[] | null | undefined,
	priceListId: number
): boolean {
	const listId = Number(priceListId);
	return (prices || []).some(
		entry =>
			Number(entry.priceListId) === listId && !isZeroListedPrice(entry.price)
	);
}

export function hasAnyPositiveListedPrice(
	prices: { price?: number }[] | null | undefined
): boolean {
	return (prices || []).some(entry => !isZeroListedPrice(entry.price));
}
